export default "__VITE_ASSET__$Wev9q9L__"